<script>
export default {
    name: 'IconDoc',
}
</script>
<template>
    <svg class="base-icon icon-doc" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M16.667 12.8V3.2c0-.849.333-1.663.927-2.263A3.15 3.15 0 0 1 19.834 0h38c.84 0 1.645.337 2.238.937.594.6.928 1.414.928 2.263V48c0 .849-.334 1.663-.928 2.263-.593.6-1.399.937-2.239.937h-9.5v9.6c0 1.766-1.425 3.2-3.188 3.2H7.188a3.14 3.14 0 0 1-2.253-.93A3.23 3.23 0 0 1 4 60.8L4.01 16c0-1.766 1.425-3.2 3.185-3.2h9.472Zm-6.327 6.4-.007 38.4H42V19.2H10.34ZM23 12.8h25.333v32h6.334V6.4H23v6.4Zm-6.333 16h19v6.4h-19v-6.4Zm0 12.8h19V48h-19v-6.4Z" clip-rule="evenodd"/></svg>
</template>